import { cn } from 'noddi-ui-common';

interface LinearProgressProps {
  className?: string;
  wrapperClassName?: string;
}

export const NoddiLinearProgressLoader = ({ className, wrapperClassName }: LinearProgressProps) => {
  return (
    <div
      className={cn(
        'relative h-1 w-full min-w-24 shrink-0 self-center overflow-hidden rounded-full bg-secondary',
        wrapperClassName
      )}
    >
      <div className={cn('h-1 w-full animate-progress-indeterminate bg-primary', className)} />
    </div>
  );
};
